import request from '@/utils/request'

export function getList (filters = {}, pagination = {}) {
  return request({
    url: '/treatment',
    method: 'get',
    headers: {
      'X-filters': JSON.stringify(filters),
      'X-pagination': JSON.stringify(pagination)
    }
  })
}

export function getDetail (id) {
  return request({
    url: '/treatment/' + id,
    method: 'get'
  })
}

export function upsert (data) {
  var method = 'post'
  var url = '/treatment'
  if (data.id) {
    method = 'put'
    url = '/treatment/' + data.id
  }
  return request({
    url,
    method,
    data
  })
}

export function measureUnits () {
  return ['mg', 'mg/kg', 'g', 'mcg', 'ml', 'IU', 'Other']
}

export function remove (id) {
  return request({
    url: '/treatment/' + id,
    method: 'delete',
  })
}

export function uploadPdf (data) {
  request.defaults.timeout = request.timeoutrequest; //issue 658
  const promise = request({
    url: '/pdf/treatment/' + data.get('id'),
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  promise.finally( e => { request.defaults.timeout = request.timeoutrequest;}) //issue 658
  return promise;
}

export function downloadPdf (id, type, filename, download = true) {
  return request({
    url: '/pdf/treatment/' + id,
    method: 'get',
    responseType: 'blob',
  }).then( response => {

      var newBlob = new Blob([response.data], {type: "application/pdf"});
      var fileURL = window.URL.createObjectURL(newBlob, { oneTimeOnly: true });
      
      if(download) {
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', filename);
        document.body.appendChild(fileLink);
        fileLink.click();
      }
      return fileURL
  })
}